import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'

const { t } = i18n.global

const DashboardSearchBarSchema = yup.object({
  group: yup.object().optional(),
  sensor: yup.object().optional(),
  period: yup
    .array()
    .of(yup.date())
    .required(
      t('errors.required', {
        label: t('dashboard.header.actions.search.fields.period'),
      }),
    )
    .test('range-less-than-two-months', t('dashboard.header.actions.search.errors.range_less_than_two_months'), (value) => {
      if (!value || value.length !== 2) return false
      const start = value[0]!
      const end = value[1]!

      return end.getTime() - start.getTime() <= 1000 * 60 * 60 * 24 * 60
    }),
})

export default DashboardSearchBarSchema
